import * as actions from "store/actions/transfer/detail";
import IUser from "Types/Transfer";
import ISplit from "Types/Split";

export interface TransferDetailState {
	item: IUser;
	splits: ISplit[];
	loading: { get: boolean; split: boolean };
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: TransferDetailState = {
	item: {},
	splits: [],
	loading: { get: false, split: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_TRANSFER: {
			return {
				...state,
				loading: { ...state.loading, get: true },
				errors: initialState.errors
			};
		}
		case actions.GET_TRANSFER_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				item: payload
			};
		}
		case actions.GET_TRANSFER_FAILED: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				errors: payload
			};
		}
		case actions.GET_SPLITS: {
			return {
				...state,
				loading: { ...state.loading, split: true },
				errors: initialState.errors
			};
		}
		case actions.GET_SPLITS_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, split: false },
				splits: payload || []
			};
		}
		case actions.GET_SPLITS_FAILED: {
			return {
				...state,
				loading: { ...state.loading, split: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
